import { RichText } from "@atlassiansox/bxp-content-framework";

import { AnalyticsAttributesProvider } from "../..";
import { UiPowerUpModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import {
    CtaColumn,
    ImageColumn,
    PowerUpGrid,
    TextColumn
} from "./UiPowerUp.styles";

export type UiPowerUpProps = {
    model: UiPowerUpModel;
};

const UiPowerUp = ({ model }: UiPowerUpProps) => {
    const { title, description, logo, button } = model.content;

    return (
        <PowerUpGrid>
            {logo && <ImageColumn>{renderViewModel(logo)}</ImageColumn>}

            <TextColumn>
                <h4>{title}</h4>
                <RichText document={description} />
            </TextColumn>

            {button && (
                <CtaColumn>
                    <AnalyticsAttributesProvider
                        value={{
                            parentLabel: title
                        }}
                    >
                        {renderViewModel(button)}
                    </AnalyticsAttributesProvider>
                </CtaColumn>
            )}
        </PowerUpGrid>
    );
};

export default UiPowerUp;
